var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var valid = ref.valid;
return [_vm._t("default"),_c('validation-watcher',{attrs:{"valid":valid,"step-index":_vm.stepIndex}})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }